export default "/images/b6d845d4f5b8128be57b2751dd384d64.avif";